module.exports = __webpack_public_path__ + "static/media/check_smarts.a79ea820.png";